<div class="pressed-button" [classByCondition]="isPressed" [cssClasses]="['clicked-pressed-button']">
    <mat-button-toggle-group>
        <mat-button-toggle [value]="buttonText" [checked]="isPressed" (change)="onButtonClick($event)">{{buttonText}}
        </mat-button-toggle>
    </mat-button-toggle-group>
</div>